// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-beta.305b9e644',
  revision: '305b9e644',
  branch: 'develop',
  date: 'Tue, 10 Mar 2026 10:21:20 GMT'
};